import { render, staticRenderFns } from "./PrecosNota.vue?vue&type=template&id=5e0751c7&scoped=true"
import script from "./PrecosNota.vue?vue&type=script&lang=js"
export * from "./PrecosNota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0751c7",
  null
  
)

export default component.exports